module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-technology-section"
  }, _vm._l((_vm.props), function(section, i) {
    return _c('div', {
      key: i,
      staticClass: "custom-technology-section__wrapper"
    }, [_c('div', {
      staticClass: "custom-technology-section__container"
    }, [_c('v-waypoint', {
      staticClass: "custom-technology-section__waypoint",
      on: {
        "waypoint-in": function($event) {
          _vm.fadeUp(i)
        }
      }
    }), _c('Title', {
      attrs: {
        "props": section.intro
      }
    }), _c('div', {
      staticClass: "custom-technology-section__row"
    }, [_c('div', {
      ref: "img",
      refInFor: true,
      staticClass: "custom-technology-section__img",
      class: {
        "order-last": section.img_right
      }
    }, [_c('img', {
      attrs: {
        "src": section.img
      }
    }), (section.img_text) ? _c('div', {
      staticClass: "custom-technology-section__img-text",
      domProps: {
        "innerHTML": _vm._s(section.img_text)
      }
    }) : _vm._e()]), _c('div', {
      staticClass: "custom-technology-section__text",
      domProps: {
        "innerHTML": _vm._s(section.text)
      }
    })])], 1)])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57e48002","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-technology-sections/custom-technology-sections.pug
// module id = 597
// module chunks = 1